<template>
  <img
    :src="require(`@/assets/img/float_${icon}.png`)"
    ref="movingImage"
    alt=""
  />
</template>
<script>
import { Noise } from "noisejs";

export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    drift: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      noise: new Noise(),
    };
  },
  mounted() {
    this.noise.seed(Math.floor(Math.random() * 64000));
    this.moveImage();
  },
  methods: {
    moveImage() {
      if (!this.$refs.movingImage) {
        requestAnimationFrame(this.moveImage);
        return;
      }

      const time = Date.now() * 0.001;
      let offsetX = 0,
        offsetY = 0;

      if (!this.limit) {
        const noiseX = this.noise.simplex2(time * 0.04, 0);
        const noiseY = this.noise.simplex2(0, time * 0.04);

        offsetX = noiseX * 50;
        offsetY = noiseY * 50;
      } else {
        const noiseX = this.noise.simplex2(time * 0.04, 0);
        const noiseY = this.noise.simplex2(0, time * 0.04);

        offsetX = noiseX * 0;
        offsetY = noiseY * 20;
      }

      const newX = 0 + offsetX;
      const newY = 0 + offsetY;

      this.$refs.movingImage.style.transform = `translate(${newX}px, ${newY}px)`;

      requestAnimationFrame(this.moveImage);
    },
  },
};
</script>

<style lang="scss" scoped></style>
